import React from "react";
import {Modal} from "antd";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { URL_SALE, URL_TANK } from "../../constants/urls";
import { PRODUCT_TYPE, TANK_STATUS_OPTIONS, TANK_STATUS_TH } from "../../constants/string";
import { dateToHumanString, dateToString, formatComma } from "../../frameworks/Util";

export default function StorageTankWaitingOrderListModal(props){
  const { open, onClose } = props;
  const tableRef = React.useRef(null);

  const columns = [
    {
      title : 'วันที่',
      dataIndex : 'created',
      key : 'created',
      render : (value) => dateToHumanString(value)
    },
    {
      title : 'Lot No',
      dataIndex : 'lot_no',
      key : 'lot_no',
      searcher : true,
    },
    {
      title : 'Produce by',
      dataIndex : 'produce_by',
      key : 'produce_by',
      searcher : true,
    },
    {
      title : 'ชื่อลูกค้า',
      dataIndex : 'buyer_name',
      key : 'buyer_name'
    },
    {
      title : 'สินค้าที่ต้องการ',
      dataIndex : 'product_name',
      key : 'product_name'
    },
    {
      title : 'ปริมาณผลิต(Kg)',
      dataIndex : 'require_weight',
      key : 'require_weight',
      render : (value) => formatComma(value)
    },
    {
      title : 'ผู้แจ้งผลิต',
      dataIndex : 'created_by_name',
      key : 'created_by_name'
    },
    {
      title : 'สถานะ',
      dataIndex : 'is_produced',
      key : 'is_produced',
      render : (value) => value ? 'ผลิตแล้ว' : 'รอผลิต'
    },
  ]

  return(
    <Modal
      title={"ใบแจ้งผลิตที่รอผลิต"}
      open={open}
      onCancel={onClose}
      okText={"ตกลง"}
      cancelText={"ยกเลิก"}
      width={1000}
      destroyOnClose
      footer={[
        <ColorButton onClick={()=> onClose()}>ปิด</ColorButton>
      ]}
    >
      <TSTable
        ref={tableRef}
        columns={columns}
        size={"small"}
        url={URL_SALE.PRODUCE_ORDER}
        params={{ type: PRODUCT_TYPE.CONCENTRATE_LATEX, is_produced : false }}
      />

    </Modal>
    
  )
}